<script>
import resources from './resources'

export default {
  name: 'professional-covenants-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Convênios Atendidos por Estabelecimento", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @hide='show = false',
          message='Ainda não existe nenhum Local de Atendimento cadastrado',
          :buttonsNext='nextStepButtonAddress',
          v-if="!statusAddress")

        ul.nav.nav-tabs
          li.active
            a.mb-cursor-point Listagem

          li(v-if="!statusAddress")
            a.mb-cursor-point(@click="onShow()") Cadastro

          li(v-if="statusAddress")
            router-link(:to="{name: 'professional.company.covenants.create'}")
                a.mb-cursor-point Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")
        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-9.col-sm-3
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.name", type='text', placeholder='Buscar Convênios')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()", type="button")
                        span.icon 
            a.mb-cursor-point(v-if="!statusAddress", @click="onShow()")
              .add-list
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Novo
                  <br>
                  | Convênio

            card-add(label='Novo<br>Convênio', route='professional.company.covenants.create', icon='', v-if="statusAddress")

            .white-bg.list-item(v-for="covenant in covenants")
              .row.border-bottom
                h4.col-xs-7.col-sm-8 {{ covenant.covenant.name }}
                .col-xs-5.col-sm-4
                  .exclude-list
                    span.icon(@click.prevent="doDelete(covenant)") 
                  router-link(:to="{name: 'professional.company.covenants.edit', params: {id: covenant.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                | {{ covenant.total_plans_served || 'Todos' }} Planos Atendidos
                br
                strong  {{ covenant.company.slug }}
          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/covenants/index/index.vue